import "./ButtonV2.css";

const ButtonV2 = (props) => {
  return (
    <button className="button-v2">
      {props.text}
      <div className="arrow-wrapper">
        <div className="arrow"></div>
      </div>
    </button>
  );
};
export default ButtonV2;
